/**
 * AppProvider
 * Combined provider that wraps all contexts in the correct order
 */

import React, { ReactNode } from "react";

import { AuthProvider } from "./AuthContext";
import { TransitionProvider } from "./TransitionContext";
import { UserProvider } from "./UserContext";

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <AuthProvider>
      <UserProvider>
        <TransitionProvider>{children}</TransitionProvider>
      </UserProvider>
    </AuthProvider>
  );
};
